module.exports = __webpack_public_path__ + "img/woo_logo.fb9be7b4.png";